var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.show)?_c('i',{staticClass:"gift material-icons clickable",on:{"click":_vm.select}},[_vm._v("card_giftcard")]):_c('div',{staticClass:"number",class:{
      'selected': _vm.selected, 
      'fade-in': _vm.show && !_vm.selected
      }},[_vm._v("\n      "+_vm._s(_vm.number)),_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("pts")])])])}
var staticRenderFns = []

export { render, staticRenderFns }